import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { useOnMount } from "./useOnMount";
export function useSubscribeOnMount(_ref, callback) {
  let {
    subscribe,
    unsubscribe
  } = _ref;
  useOnMount(() => {
    const id = generateUniqueId('observable-callback');
    subscribe({
      id,
      callback
    });
    return () => unsubscribe(id);
  });
}